<template>
	<div class="performanceStatistics">
		
		<PageHeader @back="goback" :content="'绩效统计'" />
		<div class="PSBox">
			<el-tabs v-model="activeName" @tab-click="handleClick">
				<el-tab-pane label="访员绩效统计" name="1"><visitorPerformanceStatistics :surveyId="surveyId" :source="source" v-if="activeName == 1"></visitorPerformanceStatistics></el-tab-pane>
				<el-tab-pane label="访问状态" name="2"><accessToTheState :surveyId="surveyId" :source="source" v-if="activeName == 2"></accessToTheState></el-tab-pane>
				<el-tab-pane label="访问记录统计" name="3"><accessRecordStatistics :surveyId="surveyId" :source="source" v-if="activeName == 3"></accessRecordStatistics></el-tab-pane>
				<el-tab-pane label="话费统计" name="4"><costStatistics :surveyId="surveyId" :source="source" v-if="activeName == 4"></costStatistics></el-tab-pane>
			</el-tabs>
		</div>
	</div>
</template>

<script>
import visitorPerformanceStatistics from './visitorPerformanceStatistics.vue';
import accessToTheState from './accessToTheState.vue';
import accessRecordStatistics from './accessRecordStatistics.vue';
import costStatistics from './costStatistics.vue';
import PageHeader from '@/components/pageHeader.vue';
export default {
	components: {
		visitorPerformanceStatistics,
		accessToTheState,
		accessRecordStatistics,
		costStatistics,
		PageHeader
	},
	data() {
		return {
			activeName: '1',
			surveyId: '',
			source: ''
		};
	},
	computed: {
		selectIndex() {
			let state;
			if (this.$route.query.source == 'df') {
				state = 3;
			} else if (this.$route.query.source == 'mf') {
				state = 4;
			}
			return state;
		}
	},
	created() {
		this.surveyId = this.$route.query.id;
		this.source = this.$route.query.source;
	},
	methods: {
		handleClick(tab, event) {
			console.log(tab, event);
		},
		goback() {
			this.$router.go(-1)
		}
	}
};
</script>

<style scoped lang="scss">
.performanceStatistics {
	margin: 0px;
	padding: 0px;
	width: 100%;
	height: 100%;
	.details_header {
		// max-width: 1200px;
		height: 60px;
		line-height: 60px;
		text-align: center;
		background-color: #0080ff;
		margin: auto;
		display: flex;
		justify-content: space-between;
		span {
			// color: #333333;
			color: #fff;
			font-size: 16px;
			padding: 0px 30px;
		}
		margin-bottom: 20px;
		cursor: pointer;
	}
	.PSBox {
		padding:0px 20px 20px 20px; 
	}
}
</style>
